module.exports = require("./fr-SC.js");